module.exports = __webpack_public_path__ + "img/lisa_s.744e6ee4.png";